import { Box, Paper, Typography, Stack, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const StatCard = ({ icon, title, value, subtitle, subtitleColor }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: "20px",
        border: (theme) => `1px solid ${theme.palette.border.light}`,
        bgcolor: "background.paper",
        width: "100%",
        boxShadow: (theme) => theme.palette.shadow.statCard,
      }}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={{
              width: 42,
              height: 42,
              flexShrink: 0,
              borderRadius: "12px",
              bgcolor: "background.subtle",
              border: (theme) => `1px solid ${theme.palette.border.subtle}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </Box>

          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              sx={{
                fontSize: { xs: 17, sm: 18 },
                fontWeight: 700,
                color: "text.primary",
                lineHeight: 1.25,
                wordBreak: "break-word",
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: 13,
                color: "text.muted",
                fontWeight: 500,
                mt: 0.35,
              }}
            >
              {value}
            </Typography>
            {subtitle ? (
              <Typography
                sx={{
                  fontSize: 12,
                  color: subtitleColor || "text.muted",
                  mt: 0.35,
                }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Stack>

        <IconButton
          size="small"
          sx={{
            color: "text.faint",
            p: 0.5,
            flexShrink: 0,
            mt: -0.25,
            "&:hover": { background: "transparent" },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Stack>
    </Paper>
  );
};

export default StatCard;
